'use client';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormDescription } from './form';
import { Switch } from './switch';
import React from 'react';

interface FormSwitchWrapperProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  control: Control<TFieldValues>;
  name: TName;
  label: string;
  description?: string;
  className?: string;
  onAutoSave?: (value: boolean, formValues: TFieldValues) => Promise<void> | void;
}

export function FormSwitchWrapper<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  name,
  label,
  description,
  className = 'flex flex-row items-center space-x-3 space-y-0 rounded-md border p-4 shadow',
  onAutoSave,
}: FormSwitchWrapperProps<TFieldValues, TName>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        const handleAutoSave = async (checked: boolean) => {
          field.onChange(checked);
          if (onAutoSave) {
            const formValues = control._getWatch();
            await onAutoSave(checked, formValues);
          }
        };

        return (
          <FormItem className={className}>
            <FormControl>
              <Switch checked={field.value} onCheckedChange={handleAutoSave} />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>{label}</FormLabel>
              {description && <FormDescription>{description}</FormDescription>}
            </div>
          </FormItem>
        );
      }}
    />
  );
}
